"use client"

import React from "react"
import { EditIcon, PlusIcon } from "lucide-react"
import { useTranslations } from "next-intl"

import { UserData } from "@/lib/intershop/interfaces/user/user"
import { ExtendedAddressRO } from "@/lib/storefront/addresses/address"
import { Button } from "@/components/ui/components"
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/components/sheet"
import EditOrCreateAddress from "@/components/common/addresses/EditOrCreateAddress"

interface AddressEditSheetProps {
  address: any
  customer: any
  user: any
  mode: "add" | "edit"
  addButtonLabel?: string
  context?: string
  type: "invoiceTo" | "shipTo" | "general"
  onSave?: (a: ExtendedAddressRO, u: UserData) => void
}

export default function AddressEditSheet({
  address,
  customer,
  user,
  mode,
  addButtonLabel,
  context,
  type,
  onSave,
}: AddressEditSheetProps) {
  const t = useTranslations("storefront")
  const [open, setOpen] = React.useState(false)

  function onSaveInternal(newAddress: ExtendedAddressRO) {
    if (onSave) {
      onSave(newAddress, user)
    }
    setOpen(false)
    //window.location.reload()
  }

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        {mode === "edit" ? (
          <button
            className="
              hover:text-primary-hover
              focus:outline-1 focus:outline-primary
              focus-visible:outline-1 focus-visible:outline-primary
            "
          >
            <EditIcon className="size-5" />
          </button>
        ) : (
          <Button
            size={(context ?? "") === "account" ? "default" : "smNoGrow"}
            variant={(context ?? "") === "account" ? "outline" : "outline_secondary"}
            className={(context ?? "") === "account" ? "bg-primary text-white max-lg:mx-auto lg:ml-auto" : ""}
          >
            <PlusIcon strokeWidth={2} className="inline" />
            <span className="ml-2">{addButtonLabel ?? t("forms.edit_address_form.add")}</span>
          </Button>
        )}
      </SheetTrigger>
      <SheetContent side={"right"} className={"flex h-dvh max-h-dvh flex-col overflow-hidden bg-ub-background"}>
        <SheetTitle className={"hidden"}>
          {mode === "add" ? t("forms.edit_address_form.add") : t("forms.edit_address_form.edit")}
        </SheetTitle>

        <div className="flex min-h-0 flex-1 flex-col">
          <h2 className="mb-4 flex flex-row gap-1 text-lg font-bold">
            <span>{mode === "add" ? t("forms.edit_address_form.add") : t("forms.edit_address_form.edit")}</span>
            <span className={"text-sm font-normal text-primary"}>*</span>
          </h2>
          <EditOrCreateAddress
            address={address}
            customer={customer}
            user={user}
            onSave={onSaveInternal}
            mode={mode}
            type={type}
            validateOnFirstRender={false}
            scrollableActions={true}
          />
        </div>
      </SheetContent>
    </Sheet>
  )
}
